const tasksEn = {
  my_tasks: "My Tasks",
  open_tasks_awaiting_action:
    "{{count}} open workflow tasks awaiting your action",
  refresh: "Refresh",
  search_by_task_type: "Filter By Action",
  search_by_entity_type: "Filter By Entity Type",
  task_type_approval: "Approval",
  task_type_update_document: "Update Document",
  task_type_queries: "Queries",
  entity_type_purchase_invoice: "Purchase Invoice",
  entity_type_supplier: "Supplier",
  entity_type_purchase: "Purchase Requisition",
  search_by_status: "Filter By Status",
  pending_tasks: "Pending Tasks",
  completed_tasks: "Completed Tasks",
  more_count: "+{{count}} more",
  more_actions: "More Actions",
  view_and_ask_queries: "View & Ask Queries",
  view_connected_workflow: "View Connected Workflow",
  connected_workflow: "Connected workflow",
  no_history_yet: "No history yet",
  finished_by: "Finished by {{details}}",
  assigned_to: "Assigned to {{details}}",
  description: "Description",
  status: "Status",
  actions: "Actions",
  entity_details: "Entity Details",
  reason: "Reason",
  reason_is_required: "Reason is required",
  reason_max_length_validation: "Reason cannot exceed 100 characters",
  approve_task: "Approve Task",
  reject_task: "Reject Task",
  approve: "Approve",
  reject: "Reject",
  review_document: "Review Document",
  review_supplier: "Review Supplier",
  ask_query: "Ask a Query",
  raise_query: "Raise Query",
  raise_query_subtitle: "Ask a question to another role in this workflow",
  submit: "Submit",
  answer_query: "Answer Query",
  answer_query_subtitle: "You can simply answer the query",
  your_answer: "Your Answer",
  enter_answer: "Enter Answer",
  answer: "Answer",
  question: "Question",
  enter_question: "Describe your query...",
  organization_role: "Organization Role",
  select_organization_role: "Select Organization Role",
  stage: "Stage",
  stage_optional: "Stage (Optional)",
  select_stage: "Select Stage",
  answer_is_required: "Answer is required",
  answer_max_length_validation: "Answer cannot exceed 1000 characters",
  question_is_required: "Question is required",
  question_max_length_validation: "Question cannot exceed 1000 characters",
  organization_role_is_required: "Organization role is required",
  stage_is_required: "Stage is required",
  query_raised_successfully: "Query raised successfully",
  query_answered_successfully: "Query answered successfully",
  task_completed_successfully: "Task completed successfully",
  no_tasks_title: "No tasks found",
  no_tasks_description: "You don't have any open tasks right now.",
  view_task_queries: "View Task's Queries",
  ask_a_query: "Ask a Query",
  add_an_answer: "Add an answer",
  asked_a_query: "{{email}} asked a query",
  user_on_date: "{{by}} on {{date}}",
  no_queries_yet: "No queries yet",
  no_answers_yet: "No answers yet",
  answers: "Answers",
  taskQueries: "Task Queries",
  allQueries: "All Queries",
  Open: "Open",
  Closed: "Closed",
  Answered: "Answered",
  Pending: "Pending",
  InProgress: "In Progress",
  Completed: "Completed",
  please_provide_a_reason: "Provide reason when approving document",
  provide_reason_when_rejecting_document:
    "Provide reason when rejecting document",
  all_queries_previously_asked:
    "All Queries previously asked against this task",
  needs_review: "Needs Review",
  needs_approval: "Needs Approval",
  post: "Post",
  discard: "Discard",
  close: "Close",
  discard_task: "Discard Task",
  close_task: "Close Task",
  provide_reason_when_discarding_task:
    "Provide a reason for discarding this task",
  provide_reason_when_closing_task: "Provide a reason for closing this task",
  review_purchase_requisition: "Review Purchase Requisition",
  review_pr: "Review (PR)",
  create_po: "Create PO",
  create_purchase_order: "Create Purchase Order",
  send_query_to: "Send to",
  send_to_role: "Role",
  send_to_user: "User",
  select_user: "Select user",
  user_is_required: "User is required",
  task_source: "Source",
  task_source_query: "Query",
  task_source_manual: "Manual",
  pending_task_count: "Pending Tasks ({{count}})",
  pending_tasks_dialog_subtitle: "Tasks awaiting action on this document",
  assigned_to_role: "Assigned To: {{role}}",
  assigned_to_users: "Assigned To: {{users}}",
  task_query_on_task: "Query raised on another task",
  no_pending_tasks: "No pending tasks",
  workflow_tasks: "Workflow Tasks",
  workflow_tasks_dialog_subtitle: "All tasks raised on this document",
  workflow_task_count: "Tasks ({{count}})",
  no_workflow_tasks: "No tasks found",
  completed_by_user: "Completed by {{user}}",
  closed_by_user: "Closed by {{user}}",
  closed_reason: "Reason: {{reason}}",
  completion_details: "Completion details",
  closure_details: "Closure details",
  completed_by: "Completed by",
  closed_by: "Closed by",
  email: "Email",
  completed_on: "Completed on",
  closed_on: "Closed on",
  task_action_pending_approval: "Pending Approval",
  task_action_review_document: "Review Document",
  task_action_query: "Query",
  task_action_finalize: "Pending Final Decision",
  task_action_review_pr: "Review Purchase Requisition",
  task_action_create_po: "Create Purchase Order",
  task_action_review_supplier: "Review Supplier",
  workflow_doc_still_unclassified: "This document is still unclassified. Classify it before continuing with the workflow",
  role: "Role",
  assigned_to_label: "Assigned to",
  close_query: "Close Query",
  query_closed_successfully: "Query closed successfully",
  pending_queries_count: "{{count}} pending queries",
  supplier_warning_not_attached:
    "No supplier is attached. Please enter email address.",
  supplier_warning_onboarding_pending:
    "Supplier onboarding is not completed. The query will be sent by email only.",
  supplier_warning_email_missing:
    "The supplier has no email address. Add one to the supplier before raising a query.",
  supplier_warning_not_found: "The attached supplier could not be found.",
  recipient_emails: "Recipient email(s)",
  query_sent_to: "Query will be sent to",
  recipient_emails_placeholder: "Type an email and press Enter (max {{max}})",
  recipient_emails_required: "At least one email address is required.",
  recipient_email_invalid: "Invalid email address: {{value}}.",
  recipient_emails_max: "A maximum of {{max}} email addresses is allowed.",
  provide_reason_when_closing_query: "Provide a reason for closing this query",
  send_to_supplier: "Supplier",
  // Connected workflow — Upcoming
  history: "History",
  upcoming: "Upcoming",
  next: "Next",
  possible: "Possible",
  one_of_these: "One of these",
  workflow_may_end: "Or the workflow may end",
  may_repeat: "May repeat",
  may_be_skipped: "May be skipped",
  upcoming_condition: "If {{parameter}} {{operation}} {{value}}",
  no_upcoming_steps: "No upcoming steps",
  assignee_source_entity_manager: "Entity owner's manager",
  assignee_source_task_manager: "Task manager",
  // All Tasks
  tasks: "Tasks",
  all_tasks: "All Tasks",
  no_permission_all_tasks: "You don't have permission to view all tasks.",
  org_tasks_count: "{{count}} tasks across your organization",
  no_org_tasks_description: "No tasks match the selected filters.",
  add_filter: "Add Filter",
  all: "All",
  filter_tasks: "Filter Tasks",
  filter_tasks_subtitle: "Narrow down the organization tasks",
  sort_by: "Sort By",
  sort_newest_first: "Newest First",
  sort_longest_waiting: "Longest Waiting",
  Discarded: "Discarded",
  origin_template: "Template",
  origin_manual: "Manual",
  origin_query: "Query",
  assignment_type: "Assignment Type",
  assignment_type_role: "Role",
  assignment_type_user: "User",
  assignment_type_supplier: "Supplier",
  entity_type: "Entity Type",
  task_action: "Action",
  created_by_system: "System",
  created_by_user: "User",
  column_task: "Task",
  column_origin: "Origin",
  column_waiting: "Waiting",
  column_created_by: "Created By",
  column_previous_step: "Previous Step",
  no_assignee: "No assignee",
  waiting_days: "{{count}} days",
  raised_on_task: "Raised on {{action}}",
};

export default tasksEn;
